// ─── BUSINESS PHONE ───────────────────────────────────────────────────────
// Shown across the site: footer, contact page, mobile menu, booking pages and
// legal pages. public/index.html keeps its own copy in the structured data for
// Google — update its "telephone" fields too if this number changes.
export const PHONE      = '+61 404 077 642';
export const PHONE_HREF = `tel:${PHONE.replace(/\s/g, '')}`; // tel:+61404077642 — no spaces, dials from anywhere
// ──────────────────────────────────────────────────────────────────────────
